import { formatDate } from "@angular/common";
import { Component, ElementRef, QueryList, ViewChildren } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, FormArray, Validators, } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { PlacePickerComponent } from "src/app/place-picker/place-picker.component";
import { ApiService } from "src/app/shared/services/api.service";
import { ToastrMsgService } from "src/app/shared/services/shared-services/toastr.service";

@Component({
  selector: 'app-add-planning',
  templateUrl: './add-planning.component.html',
  styleUrl: './add-planning.component.css'
})
export class AddPlanningComponent {
  planningForm!: FormGroup;
  locationForm!: FormGroup;
  clientForm!: FormGroup;
  selectedDomain = '';
  domainOptions:any = [];

  domainFields: { [key: string]: any[] } = {
    Residential: [
      { key: 'apartment_layout_plans', label: 'Apartment Layout Plans', type: 'text', value: '2BHK, 3BHK configurations' },
      { key: 'green_space_allocation', label: 'Green Space Allocation', type: 'text', value: '5,000 sq ft' },
      { key: 'parking_design', label: 'Parking Design', type: 'text', value: '200 spaces' }
    ],
    Commercial: [
      { key: 'hvac_planning', label: 'HVAC Planning', type: 'text', value: 'Centralized system' },
      { key: 'elevator_count', label: 'Elevator Count', type: 'number', value: 6 },
      { key: 'fireSafety_design', label: 'Fire Safety Design', type: 'text', value: 'Sprinklers, exits' }
    ],
    Educational: [
      { key: 'curriculum_zones', label: 'Curriculum Zones', type: 'text', value: 'Science, Arts, Sports' },
      { key: 'accessibility_features', label: 'Accessibility Features', type: 'text', value: 'Ramps, Elevators' },
      { key: 'library_capacity', label: 'Library Capacity', type: 'number', value: 10000 }
    ],
    Water: [
      { key: 'pipeline_network_plan', label: 'Pipeline Network Plan', type: 'text', value: '20 km' },
      { key: 'filtration_system_specs', label: 'Filtration System Specs', type: 'text', value: 'Multi-stage filters' },
      { key: 'pump_station_locations', label: 'Pump Station Locations', type: 'number', value: 3 }
    ],
    Power: [
      { key: 'substation_design', label: 'Substation Design', type: 'text', value: '132 kV layout' },
      { key: 'transformer_capacity', label: 'Transformer Capacity', type: 'text', value: '10 MVA' },
      { key: 'load_forecasting', label: 'Load Forecasting', type: 'text', value: 'Peak demand projections' }
    ],
    Gas: [
      { key: 'pressure_regulationPlan', label: 'Pressure Regulation Plan', type: 'text', value: '60 psi to 30 psi' },
      { key: 'valve_station_count', label: 'Valve Station Count', type: 'number', value: 5 },
      { key: 'safety_protocols', label: 'Safety Protocols', type: 'text', value: 'Leak detection systems' }
    ],
    Telecom: [
      { key: 'network_topology', label: 'Network Topology', type: 'text', value: 'Ring, Star' },
      { key: 'signal_strength_mapping', label: 'Signal Strength Mapping', type: 'text', value: '95% coverage' },
      { key: 'equipment_rack_layout', label: 'Equipment Rack Layout', type: 'text', value: '42U standard racks' }
    ],
    Road: [
      { key: 'road_alignment_plan', label: 'Road Alignment Plan', type: 'text', value: 'Straight, Curved' },
      { key: 'drainage_design', label: 'Drainage Design', type: 'text', value: 'Side drains, culverts' },
      { key: 'traffic_flow_modeling', label: 'Traffic Flow Modeling', type: 'text', value: 'Peak hour simulations' }
    ],
    Consultancy: [
      { key: 'planning_methodology', label: 'Planning Methodology', type: 'text', value: 'Agile, Waterfall' },
      { key: 'client_review_schedule', label: 'Client Review Schedule', type: 'text', value: 'Weekly reviews' },
      { key: 'documentation_format', label: 'Documentation Format', type: 'text', value: 'PDF, DOCX' }
    ],
  };
  userD: any;
  organizationId: any;
  projectId: any;
  branchList: any;
  branchShow = false;
  allState: any
  allDistricts: any
  allSubDistricts: any
  allVillage: any;
  availableStates: any[] = [];
  availableCities: any[] = [];
  proShow = true
  projectList: any
  constructor(private fb: FormBuilder,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private router: Router, private route: ActivatedRoute, private dialog: MatDialog) { }


  ngOnInit(): void {
    const user = localStorage.getItem('user') as any;
    this.userD = JSON.parse(user);
    this.organizationId = this.userD.user.org_id;
    this.fetchBranchList()
    this.route.params.subscribe((params) => {
      this.projectId = params['id'];

    });
    if (this.projectId) {
      this.proShow = false
      this.onProjectPlanningId()
    }
    this.planningForm = this.fb.group({
      company_name: [this.userD.user.org_name, Validators.required],
      company_id: [this.userD.user.org_id, Validators.required],
      company_code: [this.userD.user.company_code, Validators.required],
      project_name: [''],
      project_id: [''],
      planning_lead: [''],
      planning_start_date: [''],
      planning_end_date: [''],
      detailed_design: [''],
      resource_allocation: [''],
      risk_assessment: [''],
      regulatory_compliance: [''],
      stakeholder_engagement: [''],
      domain: [''],
      stage: ['Planning'],
    });

    this.locationForm = this.formBuilder.group({
      location: this.formBuilder.array([this.createLocationGroup()])
    });
    this.availableStates[0] = [];
    this.availableCities[0] = [];

    this.clientForm = this.formBuilder.group({
      client_name: ["", Validators.required],
      contact_person: ["", Validators.required],
      contact_number: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      khasra_no: ["", Validators.required],
      area: ["", Validators.required],
      state: ["", Validators.required],
      district: ["", Validators.required],
      subDistrict: ["", Validators.required],
      villages: ["", Validators.required],
      client_id: [""],

    });

    this.fetchData()
    this.getstates()
  }
  fetchData() {
    this.apiService.getlistDesignStages().subscribe({
      next: (res: any) => {
        this.projectList = res.data
        // this.dataSource.data = res.data;
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }
  onProjectChange(selectedBranchId: any) {
    this.apiService.getDesignStageById(selectedBranchId).subscribe({
      next: (res: any) => {
        this.planningForm.patchValue({
          project_name: res.project_name,
          project_id: res.id,
          planning_lead: res.design_lead,
          planning_start_date: res.design_start_date,
          planning_end_date: res.design_end_date,
          detailed_design: res.design_software_used,
          resource_allocation: res.resource_allocation,
          risk_assessment: res.risk_assessment,
          regulatory_compliance: res.regulatory_compliance,
          stakeholder_engagement: res.stakeholder_engagement,
          domain: res.domain,


        });

        const client = res
        this.clientForm.patchValue({
          client_name: client.client_name,
          contact_person: client.contact_person,
          contact_number: client.contact_number,
          state: client.state,
          district: client.district,
          sub_district: client.sub_district,
          villages: client.villages,
          khasra_no: client.khasra_no,
          area: client.area,
          client_id: client.client_id

        });


        const lData = res?.location || [];
        const branchFormArray = this.location;
        branchFormArray.clear();


        lData.forEach((loc: {
          address_line_2: string;
          address_line_1: string; country: any; state: any; city: any; lat: any; long: any; pincode: any; officename: any;
        }, index: number) => {
          const branchGroup = this.createLocationGroup();
          this.location.push(branchGroup);

          // Step 1: Patch country and trigger state dropdown
          branchGroup.patchValue({ country: loc.country || '' });
          this.onCountryBChange(index); // load states for this country

          // Step 2: Wait a bit to ensure states are loaded, then patch state and trigger cities
          setTimeout(() => {
            branchGroup.patchValue({ state: loc.state || '' });
            this.onStateBChange(index); // load cities for this state

            // Step 3: Patch remaining fields
            branchGroup.patchValue({
              city: loc.city || '',
              lat: loc.lat || '',
              long: loc.long || '',
              pincode: loc.pincode || '',
              officename: loc.officename || '',
              address_line_1: loc.address_line_1 || '',
              address_line_2: loc.address_line_2 || '',
            });
          }, 200); // delay to allow API call for states to finish
        });

        // If empty:
        if (branchFormArray.length === 0) {
          branchFormArray.push(this.createLocationGroup());
        }

        this.onDomainChange(this.planningForm.value.domain)
         this.onDomainChange(this.planningForm.value.domain)
        this.domainFields[this.planningForm.value.domain].forEach(field => {
          if (res.hasOwnProperty(field.key)) {
            this.planningForm.get(field.key)?.patchValue(res[field.key]);
          }
        });

        this.getdistricts()
        this.getsubdistricts()
        this.getvillages()



      },
      error: (err) => {

        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });

  }
  onProjectPlanningId() {
    this.apiService.getProjectplanningId(this.projectId).subscribe({
      next: (reso: any) => {
        const res=reso.data
        this.planningForm.patchValue({
          project_name: res.project_name,
          project_id: res.id,
          planning_lead: res.planning_lead,
          planning_start_date: res.planning_start_date,
          planning_end_date: res.planning_end_date,
          detailed_design: res.detailed_design,
          resource_allocation: res.resource_allocation,
          risk_assessment: res.risk_assessment,
          regulatory_compliance: res.regulatory_compliance,
          stakeholder_engagement: res.stakeholder_engagement,
          domain: res.domain,


        });

        const client = res
        this.clientForm.patchValue({
          client_name: client.client_name,
          contact_person: client.contact_person,
          contact_number: client.contact_number,
          state: client.state,
          district: client.district,
          subDistrict: client.sub_district,
          villages: client.villages,
          khasra_no: client.khasra_no,
          area: client.area,
          client_id: client.client_id

        });


        const lData = res?.location || [];
        const branchFormArray = this.location;
        branchFormArray.clear();


        lData.forEach((loc: {
          address_line_2: string;
          address_line_1: string; country: any; state: any; city: any; lat: any; long: any; pincode: any; officename: any;
        }, index: number) => {
          const branchGroup = this.createLocationGroup();
          this.location.push(branchGroup);

          // Step 1: Patch country and trigger state dropdown
          branchGroup.patchValue({ country: loc.country || '' });
          this.onCountryBChange(index); // load states for this country

          // Step 2: Wait a bit to ensure states are loaded, then patch state and trigger cities
          setTimeout(() => {
            branchGroup.patchValue({ state: loc.state || '' });
            this.onStateBChange(index); // load cities for this state

            // Step 3: Patch remaining fields
            branchGroup.patchValue({
              city: loc.city || '',
              lat: loc.lat || '',
              long: loc.long || '',
              pincode: loc.pincode || '',
              officename: loc.officename || '',
              address_line_1: loc.address_line_1 || '',
              address_line_2: loc.address_line_2 || '',
            });
          }, 200); // delay to allow API call for states to finish
        });

        // If empty:
        if (branchFormArray.length === 0) {
          branchFormArray.push(this.createLocationGroup());
        }

        this.onDomainChange(this.planningForm.value.domain)
         this.domainFields[this.planningForm.value.domain].forEach(field => {
          if (res.hasOwnProperty(field.key)) {
            this.planningForm.get(field.key)?.patchValue(res[field.key]);
          }
        });

        this.getdistricts()
        this.getsubdistricts()
        this.getvillages()



      },
      error: (err) => {

        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });

  }

  get location() {
    return this.locationForm.get('location') as FormArray;
  }

  createLocationGroup(): FormGroup {
    return this.formBuilder.group({
      lat: ['', Validators.required],
      long: ['', Validators.required,],
      city: ['', Validators.required,],
      state: ['', Validators.required],
      country: ['', Validators.required],
      pincode: ['', Validators.required],
      address_line_1: ["", Validators.required],
      address_line_2: ["", Validators.required],
    });
  }

  addBranch() {
    this.location.push(this.createLocationGroup());
    const index = this.location.length - 1;
    this.availableStates[index] = [];
    this.availableCities[index] = [];
  }

  removeBranch(index: number) {
    if (this.location.length > 1) {
      this.location.removeAt(index);
    }
    this.availableStates.splice(index, 1);
    this.availableCities.splice(index, 1);
  }
  onDomainChange(domain: string) {
    this.selectedDomain = domain;

    // Remove previous domain-specific controls
    Object.keys(this.planningForm.controls).forEach(key => {
      if (key !== 'domain' && this.domainFields[domain]?.find(field => field.key === key) === undefined &&
        Object.values(this.domainFields).flat().some(field => field.key === key)) {
        this.planningForm.removeControl(key);
      }
    });

    // Add new domain-specific controls
    this.domainFields[domain].forEach(field => {
      this.planningForm.addControl(field.key, this.fb.control(field.value));
    });
  }


  onSubmit(): void {
    if (this.projectId) {
      const formData = {
        ...this.planningForm.value,
        ...this.locationForm.value,
        ...this.clientForm.value
      };
      this.apiService.updateProjectplanning(this.projectId, formData).subscribe({
        next: (res) => {
          this.toastrMsgService.success("Project updated successfully");
          this.router.navigate(["/home/planning-stage-list"]);
        },
        error: (err) => {
          this.toastrMsgService.error(err.error.errorMessage);
        },
        complete: () => '',
      });
    }
    else {
      if (this.planningForm.valid) {
      } else {
        this.planningForm.markAllAsTouched();
      }
      const formData = {
        ...this.planningForm.value,
        ...this.locationForm.value,
        ...this.clientForm.value
      };
      this.apiService.saveProjectplanning(formData).subscribe({
        next: (res) => {
          this.toastrMsgService.success("Project saved successfully");
          this.router.navigate(["/home/planning-stage-list"]);
        },
        error: (err) => {
          this.toastrMsgService.error(err.error.errorMessage);
        },
        complete: () => '',
      });
    }
  }



  fetchBranchList() {
    this.apiService.getOrganizationsBranch(this.organizationId).subscribe({
      next: (res: any) => {
        if (res.data.length != 0) {
          this.branchList = res.data;;
          this.branchShow = true
        } else {
          this.planningForm.get('companyName')?.setValue(this.userD.user.org_name);
          this.planningForm.get('companyId')?.setValue(this.userD.user.org_id);
        }
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.message);
      },
      complete: () => '',
    });
  }
  onBranchChange(selectedBranchId: any) {
    const selectedBranch = this.branchList.find((b: { branch_id: any; }) => b.branch_id === selectedBranchId);
    const manager = selectedBranch?.primary_contact_name || '';
    this.planningForm.get('branchId')?.setValue(manager);
  }

  openPicker(index: number, branch: any) {
    const dialogRef = this.dialog.open(PlacePickerComponent, {
      width: '600px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        branch.patchValue({
          lat: result.lat,
          long: result.lng
        });
      }
    });
  }

  onCountryBChange(index: number) {
    const branch = this.location.at(index);
    const selectedCountry = branch.get('country')?.value;
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.availableStates[index] = res ? res : []
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
    branch.patchValue({ state: '', city: '' });
  }

  onStateBChange(index: number) {
    const branch = this.location.at(index);
    const selectedCountry = branch.get('country')?.value;
    const selectedState = branch.get('state')?.value;
    this.apiService.getdistricts(selectedState).subscribe({
      next: (res) => {
        this.availableCities[index] = res ? res : [];
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
    branch.patchValue({ city: '' });
  }


  getstates() {
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.allState = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }

  getdistricts() {
    const state = this.clientForm.value.state;
    this.apiService.getdistricts(state).subscribe({
      next: (res) => {
        this.allDistricts = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }
  getsubdistricts() {
    const state = this.clientForm.value.state;
    const district = this.clientForm.value.district;
    this.apiService.getSubdistricts(state, district).subscribe({
      next: (res) => {
        this.allSubDistricts = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }

  getvillages() {
    const state = this.clientForm.value.state;
    const district = this.clientForm.value.district;
    const subdistrict = this.clientForm.value.subDistrict;
    this.apiService.getvillages(state, district, subdistrict).subscribe({
      next: (res) => {
        this.allVillage = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }
}
